import React, {Component} from 'react';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import classNames from "classnames";

const ValidatedSelect = (props) => {
    const {meta: {touched, error}} = props;
    const className = ` form-group mb-3 ${touched && error ? 'has-danger' : ''}`;
    return (
        <div className={className}>
            <Select
                {...props}
                value={props.input.value}
                options={props.options}
                onChange={(val) => {
                    console.log(val);
                    if (val !== null) {
                        props.input.onChange(val.value)
                    } else {
                        props.input.onChange(val)
                    }
                }}
                clearable={true}
                onBlur={() => props.input.onBlur(props.input.value)}
                searchable={true}
            />
            <div className={classNames('form-control-feedback', 'error-block', {'hidden-xs-up': !error})}>
                {touched ? error : ''}
            </div>
        </div>

    );

};

export default ValidatedSelect;


// WEBPACK FOOTER //
// ./web/src/components/common/ValidatedReactSelect.jsx